import type { PermitStatus } from "../types";

const labels: Record<PermitStatus, string> = { in_review: "In review", issued: "Issued", completed: "Completed" };
export function Status({ status }: { status: PermitStatus }) {
  return <span className={`status status-${status}`}><i />{labels[status]}</span>;
}
